import "../../utils/tailwind.css";
import { PageProvider, useBlogsProvider } from "./provider";
import Label from "../../components/label";
import Section from "../../components/section";
import Tableloader from "../../components/table-loader";
import moment from "moment";

export default function AddUser() {
  return (
    <div className="p-3">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const { getLeadsQuery, handlePageChange, currentPage } = useBlogsProvider();

  if (getLeadsQuery?.isPending) {
    return <Tableloader />;
  }

  const leads = getLeadsQuery?.data?.data?.data?.filter((v) => v.type === "subscribe") || [];
  const paging = getLeadsQuery?.data?.data?.paging || {};

  return (
    <Section className="h-[80vh] overflow-y-auto mt-5">
      <div className="mt-3 overflow-x-auto mb-10">
        <table className="w-full table-fixed border-collapse border border-gray-300">
          <thead className="bg-gray-200">
            <tr>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[3%]">SR No.</th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[14%]">Email</th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[15%]">Lead Type</th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[15%]">Created At</th>
            </tr>
          </thead>

          <tbody>
            {leads?.map((item, index) => (
              <tr key={index}>
                <td className="border border-gray-300 px-2 py-2 break-words text-center whitespace-normal w-[6%]">
                  <Label className="mb-0 text-black text-[15px]" label={`${index + 1}.`} />
                </td>

                <td className="border border-gray-300 px-2 py-2 break-words whitespace-normal w-[30%]">
                  <Label className="mb-0 text-[15px]" label={item.email} />
                </td>
                <td className="border border-gray-300 px-2 py-2 break-words whitespace-normal w-[15%]">
                  <Label className="mb-0 text-[15px]" label="Subscribe" />
                </td>
                <td className="border border-gray-300 px-2 py-2 break-words whitespace-normal w-[15%]">
                  <Label className="mb-0 text-[15px]" label={moment(item.created_at).format("DD/MM/YYYY")} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="flex justify-end mt-4 pr-4">
          <div className="flex gap-2">
            {Array.from({ length: paging.total_pages || 1 }, (_, i) => i + 1).map((pageNo) => (
              <button
                key={pageNo}
                onClick={() => handlePageChange(pageNo)}
                className={`px-3 py-1 border rounded ${currentPage === pageNo ? "bg-black text-white" : "bg-white text-black"}`}
              >
                {pageNo}
              </button>
            ))}
          </div>
        </div>
      </div>
    </Section>
  );
}
